import React from "react"
import * as Theme from "../components/styles"
import loading_icon from "../images/loading_icon.gif"

export const LoadingIcon = () => {
  return <Theme.LoadingIcon src={loading_icon} alt={"Spinning Loading Icon"} />
}
